import React, { createContext, useState, useEffect, useContext } from 'react';


// Create the Email Context
const UserContext = createContext(null);

// Custom Hook to use the User Context
export const useUser = () => useContext(UserContext);


// Provider Component
export const UserProvider = ({ children }) => {
  const [user, setUser] = useState({
    email: '',
    name: '',
    mobileNumber: '',
    newMember: false,
    existingHouseholdLastName: '',
    inputFields: '',
    ttl: 0, // Time to live for session or token
  });

  // Function to update individual fields dynamically
  const updateUser = (key, value) => {
    setUser((prev) => ({ ...prev, [key]: value }));
  };

  return (
    <UserContext.Provider value={{ user, updateUser }}>
      {children}
    </UserContext.Provider>
  );  

}